import styled from 'styled-components';

export const StyledStatusContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  display: ${({ theme }) => theme.display.flex};
  justify-content: ${({ theme }) => theme.justifyContent.spaceBetween};
`;
